import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

const ProfileCompletionModal = ({ isOpen, onClose, percentage }) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" onClose={onClose} className="relative z-50">
        {/* Backdrop with smooth blur and transparency */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100 backdrop-blur-sm"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 backdrop-blur-sm"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/30 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-90"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-90"
          >
            <Dialog.Panel className="relative bg-white rounded-2xl shadow-xl max-w-md w-full p-6">
              <button
                onClick={onClose}
                className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition"
              >
                <FaTimes size={20} />
              </button>

              <div className="flex flex-col items-center text-center">
                <Sparkles className="w-12 h-12 text-pink-500 mb-2" />
                <Dialog.Title className="text-xl font-bold text-gray-800 mb-1">
                  Complete Your Profile
                </Dialog.Title>
                <p className="text-gray-600 text-sm mb-4 px-2">
                  Your profile is currently
                  <span className="text-pink-600 font-semibold mx-1">
                    {percentage}%
                  </span>
                  complete. Complete it to increase your visibility and get
                  better matches!
                </p>

                <Link
                  to="profile-update"
                  className="bg-pink-600 text-white rounded-full text-decoration-none px-5 py-2 font-medium hover:bg-pink-700 transition"
                >
                  Complete Profile Now
                </Link>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ProfileCompletionModal;
